import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import styles from './ProductSpecificationsTable.module.scss';

const SpecItem = ({ item, activeItem }) => {
  return (
    <div className={classNames({ [styles.active]: activeItem })}>
      <dl className={styles.productSpecs}>{item?.name?.toString() || '-'}</dl>
      <dl className={styles.productSpecs}>{item?.value?.toString() || '-'}</dl>
    </div>
  );
};

const SpecGroup = ({ feature, activeItem, index, onToggle }) => {
  return (
    <dl className={styles.productDetails} key={index}>
      <dt
        onClick={(e) => onToggle(feature.group, e)}
        className={activeItem ? styles.productGroupActive : styles.productGroup}
      >
        {feature.group}
      </dt>
      {feature?.items?.map((x, index) => (
        <SpecItem item={x} activeItem={activeItem} index={index} key={`spec-item-${index}-${x.name}`} />
      ))}
    </dl>
  );
};

export const ProductSpecificationsTable = ({ specs, activeAccordionItem, onToggle, specificationsHeader }) => {
  return (
    <div className={classNames(styles.productSpecificationsTable, 'col-12-xs')}>
      <h3 ref={specificationsHeader}>
        <FormattedMessage id="common.product_specifications" defaultMessage="Product specifications" />
      </h3>
      {specs?.map((feature, index) => {
        const activeItem = activeAccordionItem === feature.group;

        return (
          <SpecGroup
            feature={feature}
            activeItem={activeItem}
            onToggle={onToggle}
            key={`spec-group-${index}-${feature.group}`}
          />
        );
      })}
    </div>
  );
};
